// packages/shared-hooks/src/clients/useClientVersion.ts
//
// `GET /clients/:id/versions/:versionId` — one historical snapshot. Loaded
// on demand from the version-history row click so the list view stays
// PII-free.
import { useQuery } from '@tanstack/react-query';
import { ClientVersionDetailSchema, type ClientVersionDetail } from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { clientsKeys } from './keys.js';

export function useClientVersion(
  clientId: string | null,
  versionId: string | null,
  options: { enabled?: boolean } = {},
) {
  const client = useApiClient();
  return useQuery<ClientVersionDetail>({
    queryKey:
      clientId && versionId
        ? clientsKeys.version(clientId, versionId)
        : ['clients', '__none__', 'versions', '__none__'],
    queryFn: ({ signal }) => {
      if (!clientId || !versionId) throw new Error('useClientVersion called without ids');
      return client.get<ClientVersionDetail>(
        `/clients/${clientId}/versions/${versionId}`,
        { signal },
        ClientVersionDetailSchema,
      );
    },
    enabled: (options.enabled ?? true) && clientId !== null && versionId !== null,
  });
}
